import { Box, ButtonBase, Typography } from '@mui/material';
import BackIcon from '@mui/icons-material/ArrowBackIos';
import { parseHTML } from '@/utils/parseHTML';
import { Img } from '@/components/blocks/MaterialImage';

interface Props {
	onClose: () => void;
}

export const ProductDetailsShoesHowToMeasure: React.FC<Props> = ({ onClose }) => (
	<Box
		sx={{
			width: '100%',
			height: '100%',
			display: 'flex',
			flexDirection: 'column',
		}}
	>
		<ButtonBase
			sx={{
				color: '#9C3F74',
				fontSize: '16px',
				width: 'fit-content',
				display: 'flex',
				alignItems: 'center',
				cursor: 'pointer',
				marginBottom: '20px',
			}}
			onClick={onClose}
		>
			<BackIcon fontSize="inherit" />
			{'Regresar a guia de tallas'}
		</ButtonBase>
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				gap: '5px',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'center',
					gap: '15px',
				}}
			>
				<Img
					src="https://dpjye2wk9gi5z.cloudfront.net/wcsstore/DpstreetStorefrontAssetStore/tallas/medida-pie-01.webp"
					sx={{
						width: { xs: '117px', md: '100px' },
						height: { xs: '117px', md: '100px' },
						flexShrink: 0,
					}}
					alt="Medida pie 1"
				/>
				<Typography
					sx={{
						fontSize: { xs: '16px', md: '17px' },
						lineHeight: { xs: '20px', md: '22px' },
						color: '#333333',
					}}
				>
					{parseHTML(
						'<strong>1.</strong> Coloca tu pie en una superficie dura sobre una hoja de papel blanca con el talón contra la pared.'
					)}
				</Typography>
			</Box>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'center',
					gap: '15px',
				}}
			>
				<Img
					src="https://dpjye2wk9gi5z.cloudfront.net/wcsstore/DpstreetStorefrontAssetStore/tallas/medida-pie-02.webp"
					sx={{
						width: { xs: '117px', md: '100px' },
						height: { xs: '117px', md: '100px' },
						flexShrink: 0,
					}}
					alt="Medida pie 2"
				/>
				<Typography
					sx={{
						fontSize: { xs: '16px', md: '17px' },
						lineHeight: { xs: '20px', md: '22px' },
						color: '#333333',
					}}
				>
					{parseHTML(
						'<strong>2.</strong> Marca con un lápiz (¡O pide ayuda!) desde tu talón hasta dónde llega tu dedo más largo'
					)}
				</Typography>
			</Box>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'center',
					gap: '15px',
				}}
			>
				<Img
					src="https://dpjye2wk9gi5z.cloudfront.net/wcsstore/DpstreetStorefrontAssetStore/tallas/medida-pie-03.webp"
					sx={{
						width: { xs: '117px', md: '100px' },
						height: { xs: '117px', md: '100px' },
						flexShrink: 0,
					}}
					alt="Medida pie 3"
				/>
				<Typography
					sx={{
						fontSize: { xs: '16px', md: '17px' },
						lineHeight: { xs: '20px', md: '22px' },
						color: '#333333',
					}}
				>
					{parseHTML(
						'<strong>3.</strong> Mide la distancia de tu pie marcada en la hoja, desde el borde de la hoja hasta la punta del pie en centímetros.'
					)}
				</Typography>
			</Box>
		</Box>
	</Box>
);
